import React, { useEffect, useState } from 'react'
import { Snackbar, Alert } from '@mui/material'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import styles from '../views/SettingAccount/SettingAccountView.module.scss'

// Helper: màu avatar theo tên
function avatarColor(str) {
  const colors = ['#22C55E', '#3B82F6', '#8B5CF6', '#F59E0B', '#EF4444', '#06B6D4']
  let h = 0
  for (let i = 0; i < (str || '').length; i++) h = str.charCodeAt(i) + ((h << 5) - h)
  return colors[Math.abs(h) % colors.length]
}

export default function ListAccount(props) {
  const {
    data,
    handleInviteCode,
    handleUnlink,
    messageUnlink,
    statusUnlink,
    messageInviteError,
    user,
    handleOpenTransferConfirm,
    setTransferedId,
    handleOpenTransfer,
  } = props

  const rows = (data && data.users) || []
  const { t } = useTranslation()

  const [unlinkTarget, setUnlinkTarget] = useState(null)
  const [showStatus, setShowStatus] = useState({ open: false, type: 'success', message: '' })

  useEffect(() => {
    if (statusUnlink) {
      setUnlinkTarget(null)
      setShowStatus({
        open: true,
        type: 'success',
        message: t('account_management.linked_account.unlink_success'),
      })
    } else if (messageUnlink?.message) {
      setShowStatus({ open: true, type: 'error', message: t('update.error_unlink') })
    }
  }, [messageUnlink, statusUnlink, messageInviteError])

  const handleConfirmUnlink = (row) => {
    handleUnlink(row)
  }

  return (
    <>
      {/* ── MEMBER LIST ── */}
      <div className={styles.accList}>
        {rows.length === 0 && (
          <p style={{ color: 'var(--text-tertiary)', fontSize: 13, padding: '16px 0', textAlign: 'center' }}>
            {t('update.no_data')}
          </p>
        )}

        {rows.map((row, idx) => {
          const isMe = row.id === user?.id
          const isLinked = !!row.usedWithUserId
          const initials = (row.name || 'U').charAt(0).toUpperCase()
          const bg = avatarColor(row.name)

          return (
            <div className={styles.accItem} key={row.id || idx}>
              {/* Avatar */}
              <div className={styles.accItemAvatar} style={{ background: bg }}>
                {initials}
              </div>

              {/* Info */}
              <div className={styles.accItemInfo}>
                <div className={styles.accItemName}>
                  {row.name}
                  {!isLinked && (
                    <span className={styles.badgeRole}>{t('setting_account.list_account_main_badge')}</span>
                  )}
                </div>
                <div className={styles.accItemSub}>
                  {row.email}
                  {row.phone && <span style={{ marginLeft: 8 }}>{row.phone}</span>}
                </div>
              </div>

              {/* Last login */}
              <div style={{ fontSize: 11.5, color: 'var(--text-tertiary)', flexShrink: 0, textAlign: 'right', marginRight: 12 }}>
                {row.lastLogin
                  ? t('setting_account.list_account_last_login', { datetime: moment(row.lastLogin).format('DD/MM/YYYY HH:mm') })
                  : '—'}
              </div>

              {/* Actions */}
              <div className={styles.accItemActions}>
                {isMe ? (
                  <span className={`${styles.btn} ${styles.btnOutline} ${styles.btnSm}`}
                    style={{ cursor: 'default', opacity: 0.7, pointerEvents: 'none' }}>
                    {t('setting_account.list_account_you')}
                  </span>
                ) : (
                  <>
                    {/* Chuyển quyền — chỉ hiện nếu user hiện tại là chính */}
                    {!user?.usedWithUserId && (
                      <button
                        className={`${styles.btn} ${styles.btnOutline} ${styles.btnSm}`}
                        onClick={() => {
                          setTransferedId(row.id)
                          handleOpenTransfer(true)
                        }}
                      >
                        {t('setting_account.list_account_transfer_btn')}
                      </button>
                    )}
                    {/* Huỷ liên kết */}
                    <button
                      id="disconnect"
                      className={`${styles.btn} ${styles.btnDangerSoft} ${styles.btnSm}`}
                      onClick={() => setUnlinkTarget(row)}
                    >
                      {t('setting_account.list_account_unlink_btn')}
                    </button>
                  </>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {/* ── UNLINK CONFIRM MODAL ── */}
      {unlinkTarget && (
        <div className={`${styles.modalOverlay} ${styles.show}`} onClick={() => setUnlinkTarget(null)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHd}>
              <span className={styles.modalTitle}>{t('setting_account.unlink_modal_title')}</span>
              <button className={styles.modalX} onClick={() => setUnlinkTarget(null)}>✕</button>
            </div>
            <div className={styles.modalBd}>
              <p style={{ fontSize: 13, lineHeight: 1.6 }}
                dangerouslySetInnerHTML={{ __html: t('setting_account.unlink_modal_body', { name: unlinkTarget.name }) }}
              />
            </div>
            <div className={styles.modalFt}>
              <button className={`${styles.btn} ${styles.btnOutline}`} onClick={() => setUnlinkTarget(null)}>
                {t('setting_account.unlink_modal_cancel')}
              </button>
              <button
                className={`${styles.btn} ${styles.btnDanger}`}
                onClick={() => handleConfirmUnlink(unlinkTarget)}
              >
                {t('setting_account.unlink_modal_confirm')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── TOAST ── */}
      <Snackbar
        open={showStatus.open}
        autoHideDuration={3000}
        onClose={() => setShowStatus((p) => ({ ...p, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => setShowStatus((p) => ({ ...p, open: false }))}
          severity={showStatus.type}
          sx={{ width: '100%' }}
        >
          {showStatus.message}
        </Alert>
      </Snackbar>
    </>
  )
}
